module.exports = __webpack_public_path__ + "img/69ne.1ba54a88.svg";